var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealerPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 64,
    viewBox: "0 0 73 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 62.5V29H58V62.5M2 26L8 21.8261M71.5 26L65.5 21.8857M8 62.5V21.8261M8 21.8261L36.5 2L65.5 21.8857M65.5 62.5V21.8857M37 51H23V62H37M37 51V62M37 51H51V62H37M30 40H44V51H30V40Z",
    stroke: "#1F7057",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerPickup);
export default __webpack_public_path__ + "static/media/dealer-pickup.33e526e571efc3642b540e0164da7282.svg";
export { ForwardRef as ReactComponent };